import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule} from "@angular/forms";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {EndpointConstant} from "@interfaces/global/endpoint.constant";
import {FavoriteAddressInterface} from "@interfaces/orders/favorite-address.interface";
import {RequestMethodsService} from "@services/request/request-methods.service";
import {CloseButtonComponent} from "../../../shared-modules/global/close-button/close-button.component";
import {MatDialogRef} from "@angular/material/dialog";
import {ConfirmationActionEnum} from "@interfaces/components/enums/confirmation-action.enum";
import {ConfirmationDialogService} from "@services/confirmation-dilog/confirmation-dilog.service";
import {BrowserService} from "@services/components/browser.service";
import {CityService} from "@services/city/city.service";
import {UpdateSubscriptionTypesEnum} from "@interfaces/orders/enums/update-subscription-types.enum";
import {GlobalSubscriptionService} from "@services/subscriptions/global-subscription.service";

@Component({
  selector: 'app-favorite-address',
  standalone: true,
  imports: [
    TranslateModule,
    NgClass,
    FormsModule,
    NgForOf,
    CloseButtonComponent,
    NgIf
  ],
  templateUrl: './favorite-address.component.html',
  styleUrl: './favorite-address.component.scss'
})
export class FavoriteAddressComponent {
  favoriteAddress!: Array<FavoriteAddressInterface>;
  selectedAddress!:FavoriteAddressInterface;
  selectedAddressId!:number;
  isMobile = false;
  @Input() type: 'dialog' | 'popup' = 'dialog';
  @Output() selectNewAddress = new EventEmitter<void>();
  @Output() addressListChanged = new EventEmitter<void>();

  constructor(
    private requestService: RequestMethodsService,
    private dialogRef: MatDialogRef<any>,
    private confirmationDialogService: ConfirmationDialogService,
    private browserService: BrowserService,
    protected cityService: CityService,
    private subscriptionService: GlobalSubscriptionService
  ) {
    this.isMobile = this.browserService.isMobileDevice;

    this.getFavoriteAddress()
  }

  close(): void {
    this.dialogRef.close()
  }

  confirm(): void {
    this.cityService.setCityId({address:this.selectedAddress});
    window.location.href = '/';
  }

  changeSelected(address:FavoriteAddressInterface ): void {
    this.selectedAddress = address;
  }

  addNewAddress(): void {
    if (this.type === 'popup') {
      this.selectNewAddress.emit();
    } else {
      this.dialogRef.close('ADD_NEW_ADDRESS');
    }
  }

  deleteFavoriteAddress(favoriteAddressId?: number) {
    this.confirmationDialogService.openConfirmationDialog({
      title: "notification.delete_address",
      content: "notification.sure_to_delete_address",
      firstButton: "notification.back",
      secondButton: "notification.delete"
    }).afterClosed().subscribe((confirm: ConfirmationActionEnum) => {
      if (confirm === ConfirmationActionEnum.APPROVE || !confirm) {
        return;
      }
      this.requestService.delete(`${EndpointConstant.favorite}-${EndpointConstant.addresses}/${favoriteAddressId}`)
        .subscribe(() => {
          this.addressListChanged.emit();
          this.getFavoriteAddress();
        })
    })
  }



  getFavoriteAddress(): void {
    this.requestService.get(`${EndpointConstant.favorite}-${EndpointConstant.addresses}`)
      .subscribe((response: Array<FavoriteAddressInterface>) => {
        this.favoriteAddress = response;
      })
  }
}
